<script lang="ts">
  import { getHasOpenCookieBanner } from "$lib/Tracking.svelte";
  import LoadingCircle from "$lib/LoadingCircle.svelte";
  import { fade } from "svelte/transition";
  import consentAnswerStore from "$lib/cookieConsent.svelte";

  const hasAcceptedFunctionalCookies = $derived($consentAnswerStore?.includes(2));
  let chat = $state(false);
  let initialChatButton = $state(true);
  let planRemoveInitialChatButton = $state(false);

  const getChatContainer = () => {
    const divs = document?.querySelectorAll("div");
    let hostElement;

    if (!divs?.length) return;

    for (let i = 0; i < divs.length; i++) {
      if (divs[i].id.includes("chat")) {
        hostElement = divs[i];
        break;
      }
    }

    return hostElement;
  };

  const toggleChatVisibility = (close: boolean) => {
    const container = getChatContainer();
    if (!container) return;
    // Toggle class sr-only
    if (!close) container.style.display = "block";
    else container.style.display = "none";
  };

  const focusTextarea = () => {
    const hostElement = getChatContainer();

    // TODO: if no hostElement, chat-script hasn't loaded -- reschedule with new setTimeout
    const textArea = hostElement?.shadowRoot?.querySelector("textarea");

    if (!textArea && hostElement) {
      // add tabindex to hostElement
      hostElement?.setAttribute("tabindex", "-1");
      // add aria-label "Chat-kontainer"
      hostElement?.setAttribute("aria-label", "Chat-kontainer");
      // focus but keep scroll
      hostElement?.focus({ preventScroll: true });
      // TODO: check if has outline in any browsers, if so remove outline, pehaps use:
      // hostElement.style.outline = "none";
    } else if (textArea) textArea.focus();
  };

  $effect(() => {
    toggleChatVisibility(getHasOpenCookieBanner() || !hasAcceptedFunctionalCookies);
  });

  $effect(() => {
    if (chat && !planRemoveInitialChatButton) {
      planRemoveInitialChatButton = true;
      setTimeout(() => {
        focusTextarea();
        initialChatButton = false;
      }, 1000);
    }
  });
</script>

{#if initialChatButton && hasAcceptedFunctionalCookies}
  <button class={[!chat && "open-chat"]} onclick={() => (chat = true)} aria-label="Åpne chat">
    <span class="sr-only" aria-live="polite">
      {#if chat}
        Laster chat …
      {/if}
    </span>
    {#if chat}
      <span in:fade class="grid place-items-center">
        <LoadingCircle />
      </span>
    {/if}
  </button>
{/if}

<svelte:head>
  {#if chat && hasAcceptedFunctionalCookies}
    <script
      class="getjenny-widget-bundle"
      src="https://ld-webchat.leaddesk.com/ce2-production-main.js"
      data-connector-Id="66405e81-8bb5-4d2d-9dc1-c93baa42c1f6"
      data-title="Chatbot"
      data-title-Alignment="center"
      data-customer-Logo-Url="https://371850.fs1.hubspotusercontent-eu1.net/hubfs/371850/%5BExt.%20System%5D%20GetJenny%20Chatbot/GetJenny2020/logos%20-%20small%20sizes%202020/customer%20logos/ishavskraft-logomark-hoved-tundra-lysning-filled.png"
      data-accent-Color="#ffd8c3"
      data-button-Label=""
      data-placeholder="Skriv din melding her"
      data-show-Getjenny-Reference="true"
      data-bot-Reply-Delay="1"
      data-welcome-Text=""
      data-disable-Chat-On-Buttons="false"
      data-chat-Location-Horizontal="right"
      data-chat-Margin-Horizontal="20px"
      data-chat-Location-Vertical="bottom"
      data-chat-Margin-Vertical="20px"
      data-open-Chat-On-Load="true"
      data-theme-Color="#d5f2ff"
      data-title-Text-Color="#062788"
      data-footer-Color="#B7B7B7"
      data-target-Element=""
      data-chat-Corners="15"
      data-bubble-Corners="15 15 0 15"
      data-use-Chat-Icon="true"
      data-chat-Icon-Shape="15 15 15 15"
      data-chat-Icon-Position="bottom: 30px; right: 30px;"
      data-show-Widget-Borders="true"
      data-shadows="0 3px 7px -1px rgba(10,10,10,.1)"
      data-background-Color="#f5f5f5"
      data-disclaimer-Text=""
      data-disclaimer-Background-Color="#eeeeee"
      data-chat-Icon-Url="https://371850.fs1.hubspotusercontent-eu1.net/hubfs/371850/%5BExt.%20System%5D%20GetJenny%20Chatbot/GetJenny2020/logos%20-%20small%20sizes%202020/customer%20logos/chat_image.png"
      data-widget-Shape="15 15 15 15"
      data-bot-Icon-Border-Radius="10"
      data-customer-Logo-Width-Percentage="25"
      data-customer-Logo-Side-Margins="10"
      data-send-Icon-Url=""
      data-enable-High-Contrast-Option="true"
      data-enable-Font-Size-Option="true"
      data-identifier=""
      data-reclickable-Buttons="true"
      data-enable-Feedback="false"
      data-chat-Icon-Width="90px"
      data-chat-Icon-Height="90px"
      data-contact-Background-Color="#ffd1ff"
      data-title-Font="arial"
      data-width="360px"
      data-height="550px"
      data-timeout="600"
      data-fixed-Size="true"
      data-footer-Url="https://leaddesk.com"
      data-input-Font="arial"
      data-button-Font="arial"
      data-footer-Text="Powered by LeadDesk"
      data-widget-Font="arial"
      data-bot-Icon-Url=""
      data-chat-Location="right"
      data-header-Exists="true"
      data-like-On-Color="#6539a1"
      data-auto-Open-Time=""
      data-bot-Icon-Width="40"
      data-like-Off-Color="#000000"
      data-background-Size="cover"
      data-bot-Icon-Height=""
      data-input-Font-Size="14"
      data-button-Font-Size="14"
      data-widget-Font-Size="16"
      data-background-Repeat="no-repeat"
      data-background-Position="center"
      data-show-avatar="no"
      data-show-attachment-button="false"
      data-background-Image-Url=""
      data-background-Transparency="1"
    ></script>
  {/if}
</svelte:head>

<style lang="postcss">
  button {
    background: transparent;
    border-radius: 999px;
    width: 90px;
    height: 90px;
    overflow: hidden;
    z-index: 9;
    border-color: transparent;
    border-style: solid;
    position: fixed;
    bottom: 30px;
    right: 30px;
    display: initial;
    overflow: hidden;
    transition: background 0.25s var(--easing);
  }

  button.open-chat {
    background: url("https://371850.fs1.hubspotusercontent-eu1.net/hubfs/371850/%5BExt.%20System%5D%20GetJenny%20Chatbot/GetJenny2020/logos%20-%20small%20sizes%202020/customer%20logos/chat_image.png")
      center center / 100% no-repeat;
  }
</style>
